import { TaskWorkStatusFragment } from "gql/graphql";
import { useTranslations } from "use-intl";
import Text from "@/shared/typography/text";
import { Hidable, Value } from "@/shared/value";
import { isTaskDone } from "../completion";
import { isTaskOverdue } from "./utils/is-task-overdue";

/**
 * Рабочий статус задачи цветом и словом: «Выполнено» / «Просрочено» / «В работе».
 * Правило одно на все экраны (дерево, вкладка работ, «Моя работа», панели),
 * поэтому экраны передают задачу как есть (её `completion`) и не решают сами.
 * `plain` убирает цвет статуса — для подписи на цветном фоне (выделенный узел дерева).
 */
export function TaskWorkStatus({
  data,
  plain,
}: {
  data?: Hidable<TaskWorkStatusFragment>;
  plain?: boolean;
}) {
  const t = useTranslations("TaskWorkStatus");

  return (
    <Value data={data}>
      {(task) => {
        if (isTaskDone(task)) {
          return (
            <Text
              as="span"
              type="inherit"
              color={plain ? "inherit" : "success"}
            >
              {t("Done")}
            </Text>
          );
        }

        if (isTaskOverdue(task)) {
          return (
            <Text
              as="span"
              type="inherit"
              color={plain ? "inherit" : "warning"}
            >
              {t("Overdue")}
            </Text>
          );
        }

        return (
          <Text
            as="span"
            type="inherit"
            color={plain ? "inherit" : "secondary"}
          >
            {t("In progress")}
          </Text>
        );
      }}
    </Value>
  );
}
